/* @flow */
import produce from 'immer'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'ADD_SLIDE':
        draft.slides.push(initialState.slides[0])
        return
      case 'CHANGE_TITLE':
        draft.title = action.value
        return
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        return
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'CHANGE_IMAGE':
        const { url, slideIdx, dimensions } = action.value
        draft.slides[slideIdx].imageUrl = url
        draft.slides[slideIdx].imgDimensions = dimensions
        draft.slides[slideIdx].imgCropParams = {}
        return
      case 'REMOVE_IMAGE':
        draft.slides.splice(action.value.slideIdx, 1)
        return
      case 'CHANGE_BUTTON_DATA':
        const { btnIdx, btnData } = action.value
        draft.buttons[btnIdx].buttonUrl = btnData.link
        draft.buttons[btnIdx].buttonText = btnData.text
        return
      case 'REMOVE_BUTTON':
        draft.buttons.splice(action.value, 1)
        return
      case 'ADD_BUTTON':
        const btnType = !draft.buttons[0]
          ? 'primary'
          : draft.buttons[0].type === 'tertiary'
          ? 'primary'
          : 'tertiary'
        if (btnType === 'primary') {
          draft.buttons.unshift({ ...initialState.buttons[0], type: btnType })
        } else {
          draft.buttons.push({ ...initialState.buttons[0], type: btnType })
        }
        return
      case 'SET_IMG_CROP_PARAMS': {
        const { imgCropParams, slideIdx } = action.value
        draft.slides[slideIdx].imgCropParams = imgCropParams
      }
    }
  })
}
